import type { Embed } from 'types/capi/content';

import EmbedComponent from '~/components/Content/Embed';

type Props = {
  embed: Embed;
};

export default function EmbeddedEmbedBlock({ embed }: Props) {
  return (
    <div className="flex w-full flex-col gap-6">
      <EmbedComponent embed={embed} />
    </div>
  );
}
